import { createClient } from '@supabase/supabase-js';

// Obtenemos las variables de entorno
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Verificamos que existan para evitar errores difíciles de encontrar
if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Faltan las variables de entorno de Supabase. Verifica tu archivo .env');
}

// Creamos el cliente único para toda la app
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    flowType: 'pkce',
    // OAuthCallbackPage handles all code exchanges explicitly — disable auto-detect
    // to prevent detectSessionInUrl from racing with our exchangeCodeForSession call.
    detectSessionInUrl: false,
  },
});